import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { MaterialModule } from './../material.module';
import { BadgeComponent } from './components/badge/badge.component';
import { ConfirmationDialogComponent } from './components/confirmation-dialog/confirmation-dialog.component';
import { DetailComponent } from './components/detail/detail.component';
import { LoadingOverlayComponent } from './components/loading-overlay/loading-overlay.component';
import { PaginatorComponent } from './components/paginator/paginator.component';
import { CamelCaseToTitleCasePipe } from './pipes/camel-case-to-title-case.pipe';

@NgModule({
  declarations: [
    BadgeComponent,
    CamelCaseToTitleCasePipe,
    ConfirmationDialogComponent,
    DetailComponent,
    LoadingOverlayComponent,
    PaginatorComponent,
  ],
  imports: [CommonModule, FormsModule, MaterialModule, ReactiveFormsModule, RouterModule],
  exports: [
    BadgeComponent,
    CamelCaseToTitleCasePipe,
    ConfirmationDialogComponent,
    DetailComponent,
    LoadingOverlayComponent,
    PaginatorComponent,
  ],
})
export class SharedModule {}
